// Side menu for the Fashion layout. Mounts the SuperMarket SideMenuDrawer and
// return-reason drawer with the same wiring layout 4 uses, so till unlink, Full
// Sync, coupons, receiptless return, layaway, estimates, sales report, cash
// drawer, offers and logout behave exactly as they do there.
//
// The three SuperMarket hooks hold no effects (only state, refs, history and
// i18n), so calling them here with the subset of arguments these handlers read
// is safe. Handlers this menu never reaches are left unused.
import React, { useState } from "react";
import { Form } from "antd";
import SideMenuDrawer from "../Retail/SuperMarket/SideMenuDrawer";
import SMReturnReasonDrawer from "../Retail/SuperMarket/SMReturnReasonDrawer";
import useSuperMarketActions from "../Retail/SuperMarket/hooks/useSuperMarketActions";
import useSuperMarketReturn from "../Retail/SuperMarket/hooks/useSuperMarketReturn";
import useSuperMarketHandlers from "../Retail/SuperMarket/useSuperMarketHandlers";
import { renderCustomerWallet as renderCustomerWalletHelper, parseTillAccessMeta } from "../Retail/SuperMarket/SMRenderHelpers";
import { useEventBus } from "../../../lib/components/EventBusProvider";
import usePOSConfigStore from "../../../stores/usePOSConfigStore";
import useAuthStore from "../../../stores/useAuthStore";
import "./fashionSideMenu.css";

const domainURL = process.env.REACT_APP_domain;

const FashionMenu = (props) => {
  const { cart, tillData, posConfig, tillLink, setIsInputFocused, cartObj, fetchWalletData } = props;
  const { dispatchEvent } = useEventBus();
  const posConfigData = { posType: usePOSConfigStore.getState().posType };
  const enableProduction = posConfigData.posType === "PRD";
  const pricePrecision = tillData?.tillAccess?.csBunit?.currencies?.[0]?.prcPrecision ?? 2;
  const CWHardwareController = tillData?.tillAccess?.cwrTill?.printTemplate?.cwController === "Y";
  const matchedSaleType = tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId;
  const returnReasons = useAuthStore.getState().tillData?.returnReasons;
  const [reasonForm] = Form.useForm();
  const [reasonPopup, setReasonPopup] = useState(false);
  const [logoutLoading, setLogoutLoading] = useState(false);

  const { onFinish, isReturnDisabled, shouldShowReturnButton } = useSuperMarketReturn({
    ...props,
    pricePrecision,
    setReasonPopup,
  });
  const { handleLogout: handleLogoutFromHook } = useSuperMarketHandlers({
    ...props,
    pricePrecision,
    posConfigData,
    domainURL,
  });
  const { tillUnlink, errorMessage, handleProductionClick, handleKeyvalue } = useSuperMarketActions({
    ...props,
    pricePrecision,
    posConfigData,
    domainURL,
    dispatchEvent,
    CWHardwareController,
    handleLogoutFromHook,
  });

  const handleLogout = async () => {
    await handleLogoutFromHook(setLogoutLoading);
  };
  const renderCustomerWallet = () => renderCustomerWalletHelper({ posConfig, cartObj, matchedSaleType, fetchWalletData });

  return (
    <>
      {tillLink && (
        <SideMenuDrawer
          {...props}
          rootClassName="fx-side"
          cart={cart}
          tillData={tillData}
          posConfig={posConfig}
          tillUnlink={tillUnlink}
          enableProduction={enableProduction}
          dispatchEvent={dispatchEvent}
          reconstructedObject={parseTillAccessMeta(tillData)}
          CWHardwareController={CWHardwareController}
          isReturnDisabled={isReturnDisabled}
          shouldShowReturnButton={shouldShowReturnButton}
          setReasonPopup={setReasonPopup}
          errorMessage={errorMessage}
          handleKeyvalue={handleKeyvalue}
          handleProductionClick={handleProductionClick}
          renderCustomerWallet={renderCustomerWallet}
          logoutLoading={logoutLoading}
          handleLogout={handleLogout}
          matchedSaleType={matchedSaleType}
          posConfigData={posConfigData}
          domainURL={domainURL}
        />
      )}
      {reasonPopup && (
        <SMReturnReasonDrawer
          reasonPopup={reasonPopup}
          setReasonPopup={setReasonPopup}
          setIsInputFocused={setIsInputFocused}
          reasonForm={reasonForm}
          onFinish={onFinish}
          posConfig={posConfig}
          returnReasons={returnReasons}
        />
      )}
    </>
  );
};

export default FashionMenu;
